
(function(){
  function syncBundlePreviews(form){
    var card=form.closest('.kc-bundle-card');
    if(!card)return;
    var previews=card.querySelectorAll('[data-kc-scarf-preview]');
    form.querySelectorAll('select').forEach(function(select,index){
      var option=select.selectedOptions[0];
      var image=previews[index];
      if(!image||!option||!option.dataset.kcImage)return;
      if(image.getAttribute('src')!==option.dataset.kcImage){
        image.removeAttribute('srcset');
        image.src=option.dataset.kcImage;
      }
      image.alt=option.textContent.trim();
    });
  }
  function init(root){
    root.querySelectorAll('[data-kc-gallery]').forEach(function(gallery){
      if(gallery.dataset.kcReady)return;
      gallery.dataset.kcReady='true';
      gallery.querySelectorAll('[data-kc-image]').forEach(function(button){
        button.addEventListener('click',function(){
          var image=gallery.querySelector('.kc-product-image');
          image.removeAttribute('srcset');
          image.src=button.dataset.kcImage;
          image.alt=button.dataset.kcAlt;
          gallery.querySelectorAll('[data-kc-image]').forEach(function(other){other.setAttribute('aria-pressed',String(other===button));});
        });
      });
    });
    root.querySelectorAll('[data-kc-bundle]').forEach(function(form){
      if(form.dataset.kcReady)return;
      form.dataset.kcReady='true';
      form.addEventListener('change',function(){syncBundlePreviews(form);});
      syncBundlePreviews(form);
      form.addEventListener('submit',async function(event){
        event.preventDefault();
        if(!form.reportValidity())return;
        var button=form.querySelector('button[type="submit"]');
        if(button.disabled)return;
        var label=button.textContent;
        var status=form.querySelector('[role="status"]');
        button.disabled=true;
        button.textContent=form.dataset.loading;
        status.textContent='';
        var variants=new Map();
        variants.set(form.dataset.crown,Number(form.dataset.crownQty));
        form.querySelectorAll('select').forEach(function(select){
          variants.set(select.value,(variants.get(select.value)||0)+1);
        });
        var items=Array.from(variants,function(pair){
          return {id:Number(pair[0]),quantity:pair[1],properties:{Bundle:form.dataset.bundle}};
        });
        var base=form.dataset.root||'/';
        if(!base.endsWith('/'))base+='/';
        var added=false;
        function reviewCart(){
          button.textContent=form.dataset.cartLink;
          button.disabled=false;
          button.type='button';
          button.addEventListener('click',function(){window.location.assign(base+'cart');},{once:true});
          form.querySelectorAll('select').forEach(function(select){select.disabled=true;});
        }
        try{
          var response=await fetch(base+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})});
          var result=await response.json();
          if(!response.ok)throw new Error(result.description||result.message||form.dataset.error);
          added=true;
          var discountResponse=await fetch(base+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({discount:form.dataset.code})});
          if(!discountResponse.ok)throw new Error(form.dataset.discountError);
          var discountedCart=await discountResponse.json();
          var offerApplied=Array.isArray(discountedCart.discount_codes)&&discountedCart.discount_codes.some(function(discount){
            return String(discount.code).toLowerCase()===form.dataset.code.toLowerCase()&&discount.applicable===true;
          });
          if(!offerApplied)throw new Error(form.dataset.discountError);
          reviewCart();
          window.location.assign(base+'checkout');
        }catch(error){
          status.textContent=added?form.dataset.discountError:form.dataset.error;
          var link=document.createElement('a');
          link.href=base+'cart';
          link.className='kc-text-link';
          link.textContent=form.dataset.cartLink;
          status.appendChild(document.createTextNode(' '));
          status.appendChild(link);
          if(added){
            reviewCart();
          }else{
            button.disabled=false;
            button.textContent=label;
          }
        }
      });
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document);});
  else init(document);
  window.addEventListener('pageshow',function(){document.querySelectorAll('[data-kc-bundle]').forEach(syncBundlePreviews);});
  document.addEventListener('shopify:section:load',function(event){init(event.target);});
})();
